module.exports = Promise.all([__parcel__import__("5L8PD"), __parcel__import__("eZgP7")]).then(() => parcelRequire('3pHq1'));